import { Plus as AddIcon } from "lucide-react";
import { Helmet } from "react-helmet";

import { UsersType } from "api/users/types";
import PageLayout from "components/layouts/PageLayout";
import { hasPermissions, useUserStore } from "components/stores/UserStore";
import UltimateButton from "components/UltimateButton";
import { useModal } from "utils/hooks/useModal";

import UsersTable from "./UsersTable";
import NewUserModal from "./UsersTable/components/NewUserModal";
import { useUsersFilter } from "./UsersTable/useUsersFilter";

const UsersPage = () => {
  const [user] = useUserStore((s) => [s.user]);
  const { filters, searchField } = useUsersFilter({
    filter: [
      {
        field: "organisation",
        operator: "is",
        value: user?.organisation?._id ?? "",
      },
    ],
  });
  const { isOpen, handleClose, handleOpen } = useModal<UsersType>();

  return (
    <>
      <Helmet title="Lendzee | User Management" />
      <PageLayout
        title="User Management List"
        subtitle="Manage users and their roles across your organisation."
        search={{
          value: searchField.value,
          onChange: searchField.onChange,
          placeholder: "Search by email",
        }}
        actions={
          hasPermissions("write:users") ? (
            <UltimateButton
              text="Add User"
              Icon={
                AddIcon as React.ComponentType<{
                  size?: number;
                  className?: string;
                  style?: React.CSSProperties;
                }>
              }
              sx={{ py: 1 }}
              onClick={() => handleOpen()}
            />
          ) : undefined
        }
      >
        <UsersTable filters={filters} />
      </PageLayout>
      {hasPermissions("write:users") && (
        <NewUserModal isOpen={isOpen} handleClose={handleClose} />
      )}
    </>
  );
};

export default UsersPage;
